
export default function DealershipBenefits() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'No Franchise Fees',
      description: 'One-time investment with no ongoing franchise fees or royalties. Keep 100% of your profits.',
      highlight: '$0 Ongoing Fees'
    },
    {
      icon: 'ri-truck-line',
      title: 'Product Supply',
      description: 'Direct access to our premium product line with wholesale pricing and priority delivery.',
      highlight: 'Wholesale Pricing'
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Marketing Campaigns',
      description: 'Professional advertising materials, digital campaigns, and brand support included.',
      highlight: 'Full Marketing Support'
    },
    {
      icon: 'ri-computer-line',
      title: 'POS & Booking Systems',
      description: 'Complete technology package including booking software, payment processing, and inventory management.',
      highlight: 'Technology Included'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Training Program',
      description: 'Comprehensive training on products, sales, installation, and business operations.',
      highlight: 'Expert Training'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Ongoing Support',
      description: '24/7 support for technical issues, business questions, and customer service assistance.',
      highlight: 'Always Available'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Territory Protection',
      description: 'Exclusive territory rights to protect your market and ensure business growth.',
      highlight: 'Protected Territory'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Growth Potential',
      description: 'Tap into the rapidly growing glamping industry with proven products and support.',
      highlight: 'High Growth Market'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Dealership Benefits</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our dealership program provides everything you need to succeed in the glamping industry. 
            No hidden fees, complete support, and proven products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-emerald-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${benefit.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>
              <p className="text-gray-600 mb-3">{benefit.description}</p>
              <div className="text-sm font-semibold text-emerald-600">{benefit.highlight}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-emerald-600 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-4">Ready to Start Your Glamping Business?</h3>
          <p className="text-emerald-100 mb-6 max-w-2xl mx-auto">
            Join our network of successful dealers and be part of the fastest-growing segment in outdoor hospitality.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-emerald-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap">
              Apply for Dealership
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-emerald-600 transition-colors whitespace-nowrap">
              Schedule Call
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
